<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                Lista Business Units
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4"
                           v-model:cols="cols"
                           :rows="rows">
                    <template v-for="(c, j) in rows" :key="j" v-slot:[`td_${j}_2`]="context">
                       <input type="checkbox" disabled :checked="c.show_crm">
                    </template>
                    <template v-for="(c, j) in rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        <input type="checkbox" disabled :checked="c.show_progetti">
                    </template>
                    <template v-for="(c, j) in rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        <router-link :to="{name:'DettaglioBusinessUnit', params:{id:context.context.row.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import Field from "@/components/Field.vue";
import businessUnitsManager from "@/api/BusinessUnits";

@Options({
    name:'BusinessUnits',
    components: {
        Loading,
        Field,
        NextTable,
        InfiniteLoading
    }
})
export default class BusinessUnits extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    rows: any[] = []
    visible = false

    mounted() {
        businessUnitsManager.businessUnits().then((res:any)=>{
            this.rows = res.data
        })
    }

    getBuPadre(id:number){
        const p = this.rows.find(el=> el.id == id)
        if(p){
            return p.nome
        }
        return ''
    }

    cols = [
        {
            name: 'Nome',
            prop: 'nome',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Etichetta',
            prop: 'label',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Visibile crm',
            prop: 'show_crm',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Visibile progetti',
            prop: 'show_progetti',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative bg-next-gray-md-dark hover:bg-next-orange hover:text-white',
            resizable: false
        }
    ]
}

</script>


<style lang="scss">

</style>
